// extracted by mini-css-extract-plugin
export var describe = "index-module--describe--GkyjQ";
export var imgContent = "index-module--imgContent--Ehddr";
export var recentNews = "index-module--recentNews--6bUKm";